import React from 'react';
import PropTypes from 'prop-types';

import RadioSwatch from '../RadioSwatch/RadioSwatch';
import { getFilterKey, getFilterValue } from '../../Utils/CollectionUtils';
import { StyledLi } from './CollectionFilterItemStyles';

var CollectionFilterItem = function CollectionFilterItem(props) {
  var filterValue = getFilterValue(props.tag.title);
  var filterActive = props.activeFilters.hasOwnProperty(getFilterKey(props.tag.title)) ? props.activeFilters[getFilterKey(props.tag.title)].includes(props.tag.title) : false;
  return React.createElement(
    StyledLi,
    {
      type: props.type,
      active: filterActive,
      onClick: !props.useLink ? function () {
        return props.handleFilterClick(props.tag.title);
      } : undefined
    },
    props.useSwatch ? React.createElement(RadioSwatch, {
      value: filterValue,
      active: filterActive,
      optionAvailable: true
    }) : props.useLink ? React.createElement(
      'a',
      { href: props.tag.url },
      filterValue
    ) : filterValue
  );
};

CollectionFilterItem.propTypes = {
  activeFilters: PropTypes.object.isRequired,
  handleFilterClick: PropTypes.func,
  tag: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  useSwatch: PropTypes.bool.isRequired,
  useLink: PropTypes.bool
};
export default CollectionFilterItem;